import { ReactComponent as UserSearchSvg } from "./user-search.svg";
const UserSearchIcon = (props) => {
  return <UserSearchSvg {...props} />;
};
export default UserSearchIcon;
